const mapRequiredHiddenFields = (form) => {
  const transpiledForm = {
    dueDateDefault: form.dueDateDefault,
    minDueDateDays: form.minDueDateDays,
    requireCoverage: form.requireCoverage,
    turnAroundTimeMessage: form.turnAroundTimeMessage,
  };
  Object.entries(form).forEach((entree) => {
    const value = entree[1];
    if (typeof value === 'object') {
      const key = entree[0];
      transpiledForm[key] = {};
      if (Array.isArray(value.hidden)) {
        value.hidden.forEach((field) => {
          if (transpiledForm[key][field]) {
            transpiledForm[key][field].h = true;
          } else {
            transpiledForm[key][field] = { h: true };
          }
        });
      }
      if (Array.isArray(value.required)) {
        value.required.forEach((field) => {
          if (transpiledForm[key][field]) {
            transpiledForm[key][field].r = true;
          } else {
            transpiledForm[key][field] = { r: true };
          }
        });
      }
    }
  });
  return transpiledForm;
};

export default mapRequiredHiddenFields;
